import { useState } from "react";

import { StyledEngineProvider, ThemeProvider, Typography } from "@mui/material";

import { mergeDarkTheme } from "@aclymatepackages/themes";
import { DefaultPaper } from "@aclymatepackages/atoms";

import MultiPartForm from "../flows/MultipartForm";

import CircularProgressWithLabel from "../../atoms/loading/CircularProgressWithLabel";
import useTransactionsUploader from "../../hooks/transactionsCsvUploader";
import useFuelCsvUploader from "../../hooks/fuelCsvUploader";
import useFlightsCsvUploader from "../../hooks/flightsCsvUploader";
import useShippingTransactionsCsvUploader from "../../hooks/shippingCsvUploader";
import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";

const MultipleTransactionsUploader = ({ open, setOpen }) => {
  const { isSimulation } = usePlatformLayoutContext();

  const transactionsCsvUploaderSteps = useTransactionsUploader({
    open,
    setOpen
  });
  const mileageCsvUploaderSteps = useFuelCsvUploader({ open, setOpen });
  const flightsCsvUploaderSteps = useFlightsCsvUploader({ open, setOpen });
  const shippingCsvUploaderSteps = useShippingTransactionsCsvUploader({
    open,
    setOpen
  });

  const [selectedOption, setSelectedOption] = useState("");

  const forms = {
    transactions: transactionsCsvUploaderSteps,
    mileage: mileageCsvUploaderSteps,
    flights: flightsCsvUploaderSteps,
    shipping: shippingCsvUploaderSteps
  };

  return (
    <MultiPartForm
      type="transactions"
      forms={forms[selectedOption]}
      setOption={setSelectedOption}
      selectedOption={selectedOption}
      onClose={() => setOpen(false)}
      submitLoadingText="Please wait while we upload your CSV..."
      loadingAnimation={
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={mergeDarkTheme}>
            <CircularProgressWithLabel />
          </ThemeProvider>
        </StyledEngineProvider>
      }
      optionsAnnotation={
        isSimulation && (
          <DefaultPaper>
            <Typography variant="body1">
              This functionality is not available in Simulation Mode but in the
              full version of Aclymate you can upload CSVs of your transactions
              to read them directly into Aclymate.
            </Typography>
          </DefaultPaper>
        )
      }
    />
  );
};

export default MultipleTransactionsUploader;
